import {Task} from "./Task.js";

export class StartMonitorTask extends Task {
  /**
   *  A task to start the supplied Monitor instance. This task can be sequenced with other tasks by
   *  a Taskmanager.
   *
   *  Example Usage:
   *
   *  someTaskManager.addTasks([
   *    new StartMonitorTask(Director.globals.mrtsEndpointMonitor),
   *    someOtherTask
   *  ]);
   *
   * @param name The StartMonitorTask's name.
   * @param monitor A Monitor instance, configured with a task to monitor.
   */
  constructor (name, monitor) {
    super();
    this.name = name;
    this.monitor = monitor;
  }

  start () {
    super.start();
    this.monitor.start();
    this.done();
  }
}
